export const ProgressDropDown = [
  {
    label: "New Application",
    value: "New Application",
    style:"new"
  },
  {
    label: "Initial Screening",
    value: "Initial Screening",
    style:"new"

  },
  {
    label: "Phone Screening",
    value: "Phone Screening",
    style:"screening"

  },
  {
    label: "Virtual",
    value: "Virtual",
    style:"screening"

  },
  {
    label: "First Interview",
    value: "First Interview",
    style:"screening"

  },
  {
    label: "Technical Interview",
    value: "Technical Interview",
    style:"screening"

  },
  {
    label: "Interviewing",
    value: "Interviewing",
    style:"screening"

  },
  {
    label: "Final Round",
    value: "Final Round",
    style:"accpeted"

  },
  {
    label: "Offer Accepted",
    value: "Offer Accepted",
    style:"accpeted"

  },
  {
    label: "Offer Pending",
    value: "Offer Pending",
    style:"pending"

  },
  {
    label: "To Be Reviewed",
    value: "To Be Reviewed",
    style:"pending"
  },
  {
    label: "Offer Rejected",
    value: "Offer Rejected",
    style:"rejected"

  },
  {
    label: "Application Rejected",
    value: "Application Rejected",
    style:"rejected"

  },
  {
    label: "Offer Sent",
    value: "Offer Sent",
    style:"accpeted"

  },
  {
    label: "Accepted but Withdrawn",
    value: "Accepted but Withdrawn",
    style:"withdrawn"

  },

  {
    label: "Application on Hold",
    value: "Application on Hold",
    style:"withdrawn"

  },
  {
    label: "Over Qualified",
    value: "Over Qualified",
    style:"rejected"

  },
  {
    label: "Future Consideration",
    value: "Future Consideration",
    style:"rejected"

  },
 
  {
    label: "Pay Approval",
    value: "Pay Approval",
    style:"accpeted"

  },
 
  {
    label: "Over Budget",
    value: "Over Budget",
    style:"rejected"

  },
  {
    label: "Postponed",
    value: "Postponed",
    style:"rejected"

  },
 
  
];

export const SourcesDropDown = [
  {
    label: "Twitter",
    value: "Twitter",
  },
  {
    label: "Instagram",
    value: "Instagram",
  },
  {
    label: "Linkedin",
    value: "Linkedin",
  },
  {
    label: "Naukri.com",
    value: "Naukri.com",
  },
  {
    label: "Campus Drive",
    value: "Campus Drive",
  },
  {
    label: "Shine.com",
    value: "Shine.com",
  },
  {
    label: "Email",
    value: "Email",
  },
  {
    label: "WhatsApp",
    value: "WhatsApp",
  },
  {
    label: "Referral",
    value: "Referral",
  },
 
];

